import { apiFetch } from '@ami/react/core';
import { FreightCarrierFilter } from './freightCarrierFilter';

const _baseEndPoint = 'freight-carriers';

export class FreightCarrier {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.contactInformation = item.contactInformation;
      this.trackingUrl = item.trackingUrl;
      this.active = item.active;
      return;
    }
    this.id = null;
    this.name = '';
    this.contactInformation = '';
    this.trackingUrl = '';
    this.active = true;
  }

  static async search(filter = new FreightCarrierFilter(), page) {
    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result.map((x) => new FreightCarrier(x));
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new FreightCarrier(entity);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }
}
